var _linearGradient, _path, _path2, _path3, _linearGradient2, _path4, _circle, _path5, _circle2, _circle3, _path6, _path7, _circle4, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8UnderConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "yE3VUAqh7aGPMWSkYy_Ria",
    x1: -308.751,
    x2: 36.906,
    y1: -79.126,
    y2: -475.567,
    gradientTransform: "matrix(1 0 0 -1 0 -426)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f44f5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e52030"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#yE3VUAqh7aGPMWSkYy_Ria)",
    d: "M44.634,37.846L25.76,7.787c0,0-0.508-1.05-1.76-1.05s-1.76,1.05-1.76,1.05L3.366,37.846 C3.366,37.846,3,38.337,3,39c0,1.105,0.895,2,2,2h38c1.105,0,2-0.895,2-2C45,38.337,44.634,37.846,44.634,37.846z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.227,36.468l-15.38-24.494c-0.365-0.582-1.328-0.582-1.693,0L7.773,36.468 c-0.193,0.309-0.204,0.697-0.028,1.016C7.921,37.803,8.256,38,8.62,38h30.76c0.364,0,0.699-0.197,0.875-0.517 C40.431,37.165,40.42,36.776,40.227,36.468z",
    opacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.804,36.734L24.424,12.24c-0.184-0.291-0.664-0.291-0.848,0L8.196,36.734 c-0.097,0.154-0.102,0.349-0.014,0.508S8.438,37.5,8.62,37.5h30.76c0.182,0,0.35-0.099,0.438-0.258S39.9,36.889,39.804,36.734z",
    opacity: 0.07
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "yE3VUAqh7aGPMWSkYy_Rib",
    x1: 8.62,
    x2: 39.38,
    y1: 24.753,
    y2: 24.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8e8e8"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#yE3VUAqh7aGPMWSkYy_Rib)",
    d: "M24,12.506L39.38,37H8.62L24,12.506"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.85,
    cy: 30.625,
    r: 0.525,
    fill: "#3b3b3b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b3b3b",
    d: "M18.697,34.32l0.975,0.383l2.417-4.717l1.057,1.767l0.442,2.846l1.081-0.124v-2.909 c0-0.118-0.021-0.235-0.063-0.346l-0.683-1.82l-3.478-1.248L18.697,34.32z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.675,
    cy: 22.4,
    r: 1.4,
    fill: "#3b3b3b"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.2,
    cy: 34.475,
    r: 0.525,
    fill: "#3b3b3b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b3b3b",
    d: "M24.1,33.95c-0.29,0-0.525,0.235-0.525,0.525c0,0.29,0.235,0.525,0.525,0.525 s0.571-0.235,0.571-0.525C24.671,34.185,24.39,33.95,24.1,33.95z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b3b3b",
    d: "M30.291,32.825c-0.049,0-0.098-0.01-0.145-0.032l-11.779-5.383c-0.176-0.08-0.253-0.288-0.173-0.464 c0.08-0.175,0.287-0.253,0.464-0.173l11.779,5.383c0.176,0.08,0.253,0.288,0.173,0.464C30.551,32.749,30.424,32.825,30.291,32.825z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 27.125,
    r: 0.525,
    fill: "#3b3b3b"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b3b3b",
    d: "M21.603,25.094l-0.906,2.612l3.349,1.53l0.499-2.158l0.589,2.656l1.173,0.536l-0.612-4.308 c-0.062-0.435-0.322-0.816-0.703-1.032l-2.154-1.222c-0.359-0.204-0.789-0.241-1.177-0.101l-1.782,0.64 c-0.212,0.076-0.392,0.224-0.508,0.417l-1.325,2.2l0.878,0.568l1.417-2.008L21.603,25.094z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b3b3b",
    d: "M32.831,33.873l-2.961-2.961c-0.255-0.255-0.669-0.255-0.924,0l-2.961,2.961 C25.57,34.289,25.864,35,26.453,35l5.911,0C32.952,35,33.247,34.289,32.831,33.873z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8UnderConstruction);
export default __webpack_public_path__ + "static/media/icons8-under-construction.60f94638abefb1072a6c8b3c83b6db7c.svg";
export { ForwardRef as ReactComponent };